import React from "react";
import AdditionalDataSection from 'components/base/AdditionalData'

function CouponAdditionalDataSection() {
    return <AdditionalDataSection showTitle />
}

export default CouponAdditionalDataSection;